import type { ExtraLink } from "@/components/site/ExtraInternalLinks";

import { getAppliedInternalLinks } from "./internal-links.functions";

/**
 * Haalt de goedgekeurde extra interne links op tijdens server-rendering, zodat
 * zoekmachines de links in de HTML zien. Bij navigatie in de browser wordt geen
 * extra verzoek gedaan, om de site snel te houden.
 */
/** Per server-instantie bewaard (10 min), zodat niet elke paginaweergave op de database wacht. */
const CACHE = new Map<string, { at: number; links: ExtraLink[] }>();
const TTL_MS = 10 * 60 * 1000;
/** Nooit langer dan dit op de database wachten: de pagina gaat voor. */
const MAX_WAIT_MS = 400;

export async function loadExtraLinks(path: string): Promise<ExtraLink[]> {
  if (!import.meta.env.SSR) return [];
  const hit = CACHE.get(path);
  if (hit && Date.now() - hit.at < TTL_MS) return hit.links;
  const fetching = (getAppliedInternalLinks({ data: { path } }) as Promise<ExtraLink[]>)
    .then((links) => {
      CACHE.set(path, { at: Date.now(), links });
      return links;
    })
    .catch(() => hit?.links ?? []);
  const timeout = new Promise<ExtraLink[]>((r) => setTimeout(() => r(hit?.links ?? []), MAX_WAIT_MS));
  return Promise.race([fetching, timeout]);
}
